<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="List of Abbreviations">
<p class="FMO"><span class="right_1" epub:type="pagebreak" id="page_xi" title="xi"><a href="#/text/00a_fm0e#list">LIST OF ABBREVIATIONS</a></span></p>
<p class="noindent">For the purpose of space, the following abbreviations are used for frequently cited sources from the period.</p>
<p class="center1"><b>Newspapers</b></p>
<div class="top">
<table>
<tbody>
<tr>
<td><p class="Table-Text">BJ</p></td>
<td><p class="Table-Text"><i>Brightmoor Journal</i></p></td>
</tr>
<tr>
<td><p class="Table-Text">CPD</p></td>
<td><p class="Table-Text"><i>Cleveland Plain Dealer</i></p></td>
</tr>
<tr>
<td><p class="Table-Text">DFP</p></td>
<td><p class="Table-Text"><i>Detroit Free Press</i></p></td>
</tr>
<tr>
<td><p class="Table-Text">DJ</p></td>
<td><p class="Table-Text"><i>Detroit Journal</i></p></td>
</tr>
<tr>
<td><p class="Table-Text">DJC</p></td>
<td><p class="Table-Text"><i>Detroit Jewish Chronicle</i></p></td>
</tr>
<tr>
<td><p class="Table-Text">DN</p></td>
<td><p class="Table-Text"><i>Detroit News</i></p></td>
</tr>
<tr>
<td><p class="Table-Text">DNT</p></td>
<td><p class="Table-Text"><i>Detroit News-Tribune</i></p></td>
</tr>
<tr>
<td><p class="Table-Text">DSFP</p></td>
<td><p class="Table-Text"><i>Detroit Sunday Free Press</i></p></td>
</tr>
<tr>
<td><p class="Table-Text">DSN</p></td>
<td><p class="Table-Text"><i>Detroit Sunday News</i></p></td>
</tr>
<tr>
<td><p class="Table-Text">DST</p></td>
<td><p class="Table-Text"><i>Detroit Sunday Times</i></p></td>
</tr>
<tr>
<td><p class="Table-Text">DT</p></td>
<td><p class="Table-Text"><i>Detroit Times</i></p></td>
</tr>
<tr>
<td><p class="Table-Text">FN</p></td>
<td><p class="Table-Text"><i>Ferndale News</i></p></td>
</tr>
<tr>
<td><p class="Table-Text">HN</p></td>
<td><p class="Table-Text"><i>Hamtramck News</i></p></td>
</tr>
<tr>
<td><p class="Table-Text">HP</p></td>
<td><p class="Table-Text"><i>Highland Parker</i></p></td>
</tr>
</tbody>
</table>
<div class="top">
<p class="center1"><b>Industry Magazines</b></p>
<div class="top">
<table>
<tbody>
<tr>
<td><p class="Table-Text">EFM</p></td>
<td><p class="Table-Text"><i>Educational Film Magazine</i></p></td>
</tr>
<tr>
<td><p class="Table-Text">EH</p></td>
<td><p class="Table-Text"><i>Exhibitors Herald</i></p></td>
</tr>
<tr>
<td><p class="Table-Text">ETR</p></td>
<td><p class="Table-Text"><i>Exhibitors Trade Review</i></p></td>
</tr>
<tr>
<td><p class="Table-Text">FD</p></td>
<td><p class="Table-Text"><i>Film Daily / Wid’s Daily</i></p></td>
</tr>
<tr>
<td><p class="Table-Text">FT</p></td>
<td><p class="Table-Text"><i>Ford Times</i></p></td>
</tr>
<tr>
<td><p class="Table-Text">M</p></td>
<td><p class="Table-Text"><i>Motography</i></p></td>
</tr>
<tr>
<td><p class="Table-Text">MFR</p></td>
<td><p class="Table-Text"><i>Michigan Film Review</i></p></td>
</tr>
<tr>
<td><p class="Table-Text">MPA</p></td>
<td><p class="Table-Text"><i>Moving Picture Age</i></p></td>
</tr>
<tr>
<td><p class="Table-Text">MPM</p></td>
<td><p class="Table-Text"><i>Motion Picture Magazine</i></p></td>
</tr>
<tr>
<td><p class="Table-Text"><span class="right_1" epub:type="pagebreak" id="page_xii" title="xii">MPN</span></p></td>
<td><p class="Table-Text"><i>Motion Picture News</i></p></td>
</tr>
<tr>
<td><p class="Table-Text">MPW</p></td>
<td><p class="Table-Text"><i>Moving Picture World</i></p></td>
</tr>
<tr>
<td><p class="Table-Text">PM</p></td>
<td><p class="Table-Text"><i>Photoplay Magazine</i></p></td>
</tr>
<tr>
<td><p class="Table-Text">R&amp;S</p></td>
<td><p class="Table-Text"><i>Reel and Slide</i></p></td>
</tr>
<tr>
<td><p class="Table-Text">V</p></td>
<td><p class="Table-Text"><i>Variety</i></p></td>
</tr>
</tbody>
</table>
<div class="top">
<p class="center1"><b>Miscellaneous</b></p>
<div class="top">
<table>
<tbody>
<tr>
<td><p class="Table-Text">E&amp;P</p></td>
<td><p class="Table-Text"><i>Editor &amp; Publisher</i></p></td>
</tr>
<tr>
<td><p class="Table-Text">PW</p></td>
<td><p class="Table-Text"><i>Photoplay Weekly</i></p></td>
</tr>
<tr>
<td><p class="Table-Text">WFN</p></td>
<td><p class="Table-Text"><i>Weekly Film News</i></p></td>
</tr>
</tbody>
</table>
</div></div></div></div></div></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 00a_fm0g.vue?26431005